<script>
import BaseNumber from './_base-number.vue'

export default {
  components: { BaseNumber },
  props: {
    from: {
      type: Number,
      default: 0,
    },
    to: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      default: 2000,
    },
    easing: {
      type: Function,
      default: (t) => {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t
      },
    },
    delay: {
      type: Number,
      required: false,
      default: 0,
    },
    shouldStart: {
      type: Boolean,
      required: false,
      default: false,
    },
    align: {
      type: String,
      required: false,
      default: 'left',
    },
    decimals: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      current: this.from,
      started: false,
    }
  },
  computed: {
    diff() {
      return this.to - this.from
    },
    rounding() {
      return this.to.toString().split('.')[1].length || 0
    },
  },
  watch: {
    shouldStart(val) {
      if (!this.started && val === true) {
        this.start()
      }
    },
    from() {
      if (this.shouldStart) {
        this.start()
      }
    },
    to() {
      if (this.shouldStart) {
        this.start()
      }
    },
  },
  created() {
    if (this.shouldStart) {
      this.start()
    }
  },
  methods: {
    step(start, stop) {
      const curr = new Date().getTime()
      if (curr > stop) {
        this.current = this.to
        return
      }
      const steps = stop - start
      const percent = (curr - start) / steps
      this.current = this.from + Math.round(this.diff * this.easing(percent))
      window.requestAnimationFrame(() => this.step(start, stop))
    },
    start() {
      window.setTimeout(() => {
        const startTime = new Date().getTime()
        const endTime = startTime + this.duration
        this.started = true
        this.step(startTime, endTime)
      }, this.delay)
    },
  },
}
</script>
<template>
  <span :class="$style.wrapper">
    <BaseNumber :number="to" :style="{ opacity: 0 }" :decimals="decimals" />
    <BaseNumber
      :class="$style.current"
      :number="current"
      :style="{
        opacity: started ? 1 : 0,
        right: align === 'right' ? 0 : 'auto',
        left: align === 'left' ? 0 : 'auto',
      }"
      :decimals="decimals"
    />
  </span>
</template>
<style lang="scss" module>
.wrapper {
  position: relative;
}
.current {
  position: absolute;
}
</style>
